const cancel = 'Отказ'
const save = 'Запиши'

export default {
  global: {
    generalError: 'Уф! Заявката не може да бъде обработена. Моля, презаредете страницата.',
    signature: 'Поздрави,',
  },

  component: {
    actionBar: {
      actions: 'Actions',
      hideActions: 'Hide actions',
      next: 'Next',
      previous: 'Previous',
    },

    addButton: {
      add: 'Add',
    },


    aiSummaryBox: {
      transcript: 'Transcript',
      summary: 'Summary',
    },

    attachments: {
      add: 'Добавете CV или други приложения',
      placeholderWithDescription: 'Добавяне на изискваните прикачени файлове',
      remove: 'Премахване',
      allowedFileTypes: 'Разрешени типове файлове',
      errors: {
        size: 'Файлът е прекалено голям, максималният размер на файла е 5MB.',
        empty: 'Файлът не съдържа данни',
        invalidType: fileType => `Съжаляваме, ${fileType} файлове не се разрешават поради съображения за сигурност`,
        typeNotWhitelisted: 'Съжаляваме, типът файл не е разрешен.',
      },
    },

    agreeTos: {
      privacyLinkText: 'Политика за поверителност',
      termsLinkText: 'Правила и условия',
      privacyPolicyText:
        'Ценим поверителността на личните ви данни, моля, прочетете нашата ',
      termsText1: 'и прочетете и приемете ',
      termsText2: 'преди да ни предоставите личните си данни.',
      privacyLink: 'https://get.recright.com/privacy-policy',
      termsLink: 'https://get.recright.com/recright-terms-and-conditions-candidate',
      privacyInfo: mail => `Ако не желаете да обработваме личните Ви данни, можете да поискате да бъдат премахнати, като ни изпратите съобщение на ${mail}.`,
      customSupportPrivacyInfo: link => `Ако не желаете да обработваме личните Ви данни, можете да поискате премахване, като се свържете с ${link}.`,
    },

    buttons: {
      close: 'Затвори',
    },

    competencies: {
      addCompetency: 'Add a new competency',
      edit: 'Edit competencies',
      done: 'Done',
      defaultsDescription: 'If you are unsure what competencies to use, we have defined some good defaults to start with.',
      getDefaults: 'Get default competencies',
    },

    competency: {
      warning: 'Remove competency and all its ratings?',
    },

    confirmDelete: {
      delete: 'Delete',
      cancel: 'Cancel',
      confirm: 'Confirm',
    },

    confirm: {
      cancel: 'Премахване на кадри',
      confirm: 'Опитай пак',
    },

    confirmButton: {
      wait: count => `Изчакай ${count}`,
      confirm: 'Потвърждение',
    },

    controlStatus: {
      text: {
        empty: 'Попълни',
        valid: () => 'Готово',
      },
      textarea: {
        empty: 'Попълни',
        valid: (length, limit) => `${length}/${limit}`,
      },
      select: {
        empty: 'Задай',
        valid: () => 'Готово',
      },
      file: {
        empty: 'Избери',
        valid: () => 'Промени',
      },
      list: {
        empty: 'Добави',
        valid: (length, limit) => `${length}/${limit}`,
      },
      search: {
        empty: 'Търсене',
        valid: () => 'Готово',
      },
    },

    emailAddresses: {
      candidateNamePlaceholder: 'Candidate name',
      remove: 'Премахване',
      importCsv: 'Import CSV',
      invalidEmails: 'Invalid emails found.',
      maxCsvEntryErrorNotification: amount =>
        `Max ${amount} csv entries allowed`,
      importCsvTooltip:
        'The csv rows can have email or email,phone. Each row represents a recipient. The phone numbers needs to be in international format (E.164) e.g. (<strong>+358</strong>50xxxxxxx).',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'Email bounced back. Make sure the recipient received your message.',
      },
      Permanent: {
        General: 'Email delivery failed. Recipients email provider rejected the message.',
        NoEmail: 'Email address does not exist.',
        Suppressed: 'Email was not delivered due to previous unsuccessful delivery attempts.',
      },
      Transient: {
        General: 'Email bounced back. Make sure the recipient received your message.',
        MailboxFull: 'Recipient inbox is full.',
        MessageTooLarge: 'The message content is too large.',
        ContentRejected: 'The message content rejected.',
        AttachmentRejected: 'The attachment rejected.',
      },
    },

    smsDeliveryStatus: {
      notDelivered: 'SMS message added to message queue, waiting for delivery.',
      failed: 'Sending SMS message failed.',
      duplicate: 'The number given is already attatched to a candidate in the interview.',
    },

    error403: {
      heading: 'Забранено',
      content: 'Нашият сървър любезно (но твърдо) отказа да изпълни заявка, направена от Вашия браузър. Имайте предвид, че Recright трябва да се използва с едно устройство / браузър (едновременно).',
      link: 'Първа страница',
    },

    error404: {
      heading: 'Няма нищо там',
      content: 'Погледнахме, но няма уеб страница на адреса, който поискахте. Може би сте проследили изтекъл линк или случайно сте въвели грешен адрес.',
      link: 'Първа страница',
    },

    error410: {
      heading: 'Затворена',
      content: 'Работната позиция не може да бъде показана, защото тя е затворена или периодът на кандидатстване е приключил.',
      link: 'Първа страница',
    },

    calendarError: {
      heading: 'Connecting calendar failed',
      content: 'We were unable to connect your calendar. Please try again later and if the issue continues please contact our support.',
    },

    cookieConsentModal: {
      title: 'Нашият уебсайт използва бисквитки',
      body: 'Приемайки всички бисквитки, вие се съгласявате да съхраняваме бисквитки на вашето устройство, за да подобрите навигацията в сайта, да анализирате използването на сайта и да подпомогнете нашите маркетингови усилия.',
      learnMoreLinkText: 'Научете повече за това как използваме бисквитки',
      learnMoreLink: 'https://get.recright.com/cookies/', // TODO add localized links when the page is translated
      manageCookies: 'Управление на бисквитки',
      acceptAll: 'Приемам всички бисквитки',
      manageTitle: 'Управление на предпочитанията за съгласие',
      necessaryCookiesTitle: 'Необходими бисквитки',
      necessaryCookiesBody:
        'Тези бисквитки са необходими за функционирането на уебсайта и не могат да бъдат изключени в нашите системи.',
      performanceCookiesTitle: 'Бисквитки за ефективност',
      performanceCookiesBody:
        'Тези бисквитки ни позволяват да броим посещенията и източниците на трафик, за да можем да измерваме и подобряваме ефективността на нашия сайт.',
      confirmChoices: 'Потвърдете избора ми',
      marketingCookiesTitle: 'Маркетингови бисквитки',
      marketingCookiesBody:
        'Тези бисквитки ни позволяват да персонализираме рекламата и да измерваме ефективността на рекламата.',
      functionalCookiesTitle: 'Функционални бисквитки',
      functionalCookiesBody:
        'Тези бисквитки се използват за подобряване на функционалността на уебсайта. Без тези бисквитки някои функции може да станат недостъпни. Примерите за функционални бисквитки включват услуги за уеб чат и потребителски предпочитания.',
    },

    flash: {
      starting: 'Подготвя се ...',
      connection_error_hint: 'Не можа да се установи връзка с мрежата.\nОпитайте да презаредите страницата.',
      permission_hint: 'Трябва да разрешите на този сайт да използва Вашата уеб камера и микрофон.',
      searching_camera_hint: 'Търсене на уеб камера ...',
      camera_reserved_hint: 'Друго приложение или уеб страница запази уеб камерата Ви.\nМоля, затворете приложението и презаредете тази страница.',
      camera_reserved_hint_chrome_extra: '\n\nУважаеми потребители на Chrome, трябва да разрешите на Recright да използва уеб камера от диалоговия прозорец под адресната лента.',
      no_camera_hint: 'Уебкамера не е открита.',
      no_mic_hint: 'Микрофон не е открит.',
      uploading_text: 'Качва се...',
      rtmpt_in_use: 'Тази стъпка няма да е необходима, ако Вашият мрежов\nадминистратор е разрешил RTMP. Попитайте ни как да стане това.',
      preview_text: 'Уебкамерата е в режим на визуализация',
      close_text: 'Затваряне на камерата',
      remove_text: 'Премахване на кадри',
      noflash_errortext_install: link => `Изглежда, че нямате Adobe Flash Player. Имате нужда от флаш приставка (flash plugin) за записване на видеоклипове. Инсталирайте флаш оттук: ${link}`,
      noflash_errortext_enable: link => `Ако вече сте инсталирали флаш, но все още виждате това съобщение. Погледнете тук: ${link}`,
      noflash_errortext_differentbrowser: 'Като алтернатива, можете да опитате с браузър, който поддържа HTML5 запис. Предлагаме Chrome или Firefox.',
    },

    footer: {
      terms: 'Условия',
      license: 'General Terms of Service',
      privacyPolicy: 'Политика за конфиденциалност',
      customSupport: link => `Свържете се с ${link}`,
      accessibilityReport: 'Accessibility report',
    },

    feedbackPulse: {
      howWouldYouRateInterview: 'Как бихте оценили интервюто си?',
      howWouldYouRateJobAd: 'Как бихте оценили процеса на кандидатстване?',
      yourResponseIsAnonymous: 'Вашето мнение е анонимно.',
      thankYouFeedback: 'Благодарим Ви за отзива!',
    },

    candidateFooter: {
      termsLink: 'https://get.recright.com/recright-terms-and-conditions-candidate',
      privacyPolicyLink: 'https://get.recright.com/privacy-policy',
      accessibilityReportLink: 'https://websitemedia.recright.com/wp-content/uploads/2024/11/06112306/accessibility_report.pdf',
    },

    formErrors: {
      typeNotWhitelisted: 'Съжаляваме, типът файл не е разрешен.',
      isRequired: 'Това поле е задължително.',
      isEmail: value => `${value} не е валиден имейл.`,
      isDate: value => `${value} не е валидна дата.`,
      invalidUrl: 'Невалиден URL',
      singleHireEndError: 'Еднократното наемане не може да се използва повече от 60 дни.',
      isNotTooOldForLive: 'Датата е в миналото.',
      isNotAfterEndDate: 'The date is after the date the job ad closes.',
      isValidMobilePhone: value => `${value ? `${value} is not` : 'Not'} a valid mobile phone number.`,
      isInternationalPhoneNumber: 'Phone number must be in international format.',
      duplicateNumber: 'Phone number has already been added',
      duplicateCompetency: 'Competency with that name already exists',
      isNotDuplicateTemplateName: 'Template with that name already exists',
    },

    jobAdApplication: {
      name: 'Име',
      city: 'Роден град',
      email: 'Електронна поща',
      phone: 'Телефонен номер',
      applyForPosition: 'Кандидатствай за позиция',
      back: 'Назад',
      continue: 'Продължи',
      submit: 'Изпрати',
      saveForLater: 'Продължете по-късно',
      namePlaceholder: 'Въведете името си',
      emailPlaceholder: 'Въведете имейла си',
      phonePlaceholder: 'Въведете телефона си',
      cityPlaceholder: 'Въведете настоящия си град',
      links: 'Добавете линк, например към Вашия профил в LinkedIn.',
      legendBasicInfo: 'Основна информация',
      legendLinks: 'Линкове',
      legendAttachments: 'Приложения',
      legendAdditionalFields: 'Допълнителна информация',
      coverLetter: 'Придружително писмо',
      attachments: 'Приложения',
      introduction: 'Представете се накратко тук',
      thankYou: 'Благодарим Ви.',
      luck: 'Успех!',
      close: 'Затвори',
      required: 'Елементите, отбелязани със * звездичка, са задължителни.',
    },

    jobAdDetails: {
      apply: 'Кандидатстване за работа',
    },

    jobAdContainer: {
      endTime: date => (date ? `отворено до ${date}` : ''),
    },

    jobAdQuickInterview: {
      back: 'Назад',
      submit: 'Изпрати',
      saveForLater: 'Продължете по-късно',
      title: 'Кратко видео интервю',
      description: 'За да Ви опознаем по-бързо, бихме искали да отговорите накратко на въпросите в нашето интервю. Дръжте се естествено и вдъхнете живот на Вашата кандидатура.',
      requiredNote: 'Обърнете внимание, че това е част от процеса на кандидатстване и отговорникът по набиране на персонал ще получи кандидатурата Ви само след като запишете Вашия отговор.',
      reminderNote: 'Може веднага да запишете отговора си или да продължите по-късно след получаване на напомнящо съобщение по имейла.',
    },

    jobAdRow: {
      responses: 'Приложения',
      status: {
        open: 'Отворено',
        filled: 'Попълнено',
        cancelled: 'Анулирано',
        done: 'Готово',
        close: 'Затвори',
        draft: 'Затворено (чернова)',
        hidden: 'Скрито',
      },
    },

    interviewRow: {
      responses: 'Кандидати',
    },

    linkedInProfile: {
      showLinkedInProfileModal: 'Покажи профила в LinkedIn',
    },

    linkedInButton: {
      error: 'Грешка при извличане на профила. Моля, опитайте отново.',
      buttonText: 'Кандидатствайте с LinkedIn',
    },

    linkedInContainer: {
      linkedInButtonDescription: 'Можете да използвате профила си в LinkedIn за автоматично попълване на формуляра за кандидатстване',
      linkedInOr: 'или',
      error: 'Грешка при извличане на профила. Моля, опитайте отново.',
    },

    linkListInput: {
      addField: 'Добави',
      removeField: 'Премахване',
      invalidUrl: 'Невалиден URL',
    },

    liveRoom: {
      greeting: name => `Hello, ${name}.`,
      notYetStarted: startTime =>
        `The interview has not yet started. The interview starts at ${startTime}.`,
      interviewTitle: title => `Interview title: ${title}`,
      interviewStartsIn: timeLeft => `The Interview starts in: ${timeLeft}`,
      interviewHasEnded: 'The interview has ended.',
      youHaveLeft: 'You have left the interview.',
      rejoinInterview: 'Rejoin interview',
      joinInterview: 'Join interview',
      goToEvaluations: 'Continue to evaluation',
      structuredInterview: {
        timeEstimateText: timeEstimate => `${timeEstimate} minutes`,
        guideNotesPlaceHolder: stepTitle => `Notes for ${stepTitle}`,
        goToNextStepButtonText: 'Go to next section',
        totalTime: 'Total time in interview:',
        timeIn: partName => `Time in ${partName}:`,
        nextStep: stepTitle => `Next up: ${stepTitle}`,
      },
    },

    loadingButton: {
      loading: 'Зарежда се...',
      saving: 'Запаметява се ...',
      sending: 'Изпраща се ...',
    },

    modalApplicationForm: {
      applyForPosition: 'Кандидатствай за позиция',
      continue: 'Продължи',
      name: 'Въведете името си',
      email: 'Въведете имейла си',
      phoneNumber: 'Въведете телефона си',
      links: 'Може да въвеждате линкове',
      legendLinks: 'Линкове',
      legendAttachments: 'Приложения',
      coverLetter: 'Придружително писмо',
      attachments: 'Приложения',
      introduction: 'Напишете въведението си тук',
      thankYou: 'Благодарим Ви.',
      luck: 'Успех!',
      close: 'Затвори',
    },

    modalConfirm: {
      cancel,
      confirm: 'ОК',
    },

    modalAlert: {
      close: 'Close',
    },

    modalLinkShare: {
      title: 'Обществен линк за споделяне',
      info: 'Ето публичният адрес на обявата за работа, който можете да споделите.\nВсеки, който се интересува от позицията, може да види обявата \nи след това да реши дали да кандидатства.\nЩе получите обичайното известие, когато заявките започнат да пристигат.\n\nЕто публичен линк към обявата за работа:',
    },

    modalVideoAdd: {
      title: 'Добавете ново видео',
      chooseTitle: 'Добавете ново видео',
      titlePlaceholder: 'Въведете заглавие на видеоклипа тук.',
      cancel,
      save,
    },

    modalVideoUpload: {
      title: 'Качете нов видеоклип',
      info: 'Максималният разрешен размер на видеоклипа е 500mb. Препоръчваме видеоклиповете да бъдат компресирани преди качването им. По този начин качването и конвертирането ще отнемат по-малко време.',
    },

    modalCandidateInfo: [
      {
        headline: 'Запишете Вашия видео отговор ',
        content: 'толкова пъти, колкото желаете. Видеоклиповете се запаметяват веднага след записа и можете да се върнете към видео интервюто чрез линка, който е изпратен на Вашия имейл.',
        mobileContent: 'толкова пъти, колкото желаете. Добавете видеото към интервюто. Ще видите как видеоклипът се качва и запаметява в интервюто. Можете да се върнете към видео интервюто чрез линка, който е изпратен на Вашия имейл. <br><br><strong>Ако екранът Ви остава черен и използвате мобилно устройство от Apple, ще намерите инструкции за това как да решите проблема <a style="text-decoration: underline;" target="_blank" rel="noopener noreferrer" href="https://support.recright.com/en/articles/11187-recording-doesn-t-work-with-ipad-iphone">тук</a>.</strong>',
      },
      {
        headline: 'След записа, ',
        content: 'уверете се, че видеоклипът се възпроизвежда правилно и гласът Ви може да бъде чут. Когато натиснете бутона „Изпрати“, Вашият отговор ще бъде заключен и няма да можете да го редактирате повече.',
      },
      {
        headline: 'Когато приключите с интервюто, ',
        content: 'натиснете бутона „Изпратете отговорите и завършете интервюто“. След това няма да можете да се върнете към видео интервюто. Ако искате да затворите страницата и да продължите с интервюто по-късно, натиснете бутона „Продължи по-късно“.',
      },
      {
        headline: 'Ако имате нужда от помощ ',
        content: mailto => `при отговор на въпросите във видео интервюто, кликнете върху бутона „Помощ“ в долната дясна част на страницата или ни изпратете имейл на ${mailto}.`,
        customContent: link => `Свържете се с ${link}`,
      },
    ],

    navigationBar: {
      back: 'Назад',
      dashboard: 'Контролно табло',
      frontpage: 'Първа страница',
    },

    personDetails: {
      stage: 'Stage',
      namePlaceholder: 'Candidate',
      contact: 'Contact',
      links: 'Links',
      attachments: 'Attachments',
      coverLetter: 'Cover Letter',
      referrer: 'Origin',
      referrerInfo: 'The website from which the candidate came to the service.',
      noStage: 'Not in any stage yet',
      lastSeen: time => `Last seen ${time}.`,
      headerAdditionalInformation: 'Additional information',
      state: {
        invited: 'Invited',
        visited: 'Visited',
        incomplete: 'Incomplete',
        completed: 'Completed',
      },
      notVisited: 'Hasn\'t yet visited the interview.',
      scheduledInterview: 'Scheduled interview',
      scheduledInterviewInvitationSent: 'Invited to a meeting',
      scheduledInterviewInvitationExpired: 'Invitation has expired',
      scheduledInterviewInvitationEventCreated: 'Meeting:',
      scheduledInterviewReScheduleMeeting: 'Reschedule meeting',
      otherPersons: count => `Also found on ${count} other positions`,
    },

    phoneInput: {
      placeholder: example => `Телефон във формат ${example}`,
    },

    questionsAndResponses: {
      response: 'Response',
      noResponse: 'No response',
      resetQuestionResponse: 'Delete candidate response',
      resetQuestionResponseConfirm: questionTitle =>
        `Are you sure you want to reset the question "${questionTitle}" for the candidate and delete their response?`,
      resetQuestionResponseConfirm2: 'If you do this, candidate can retake this question.',
      aiInsights: 'AI Insights',
      showQuestion: 'Show question video',
      hideQuestion: 'Hide question video',
      question: 'Question',
      nonAnswerableInfo: 'Question is non-answerable.',
      evaluationCriteriaLabel: 'Evaluation criteria',
    },

    rating: {
      ownVote: 'Your rating',
      yourVotePlaceholder: 'You have not voted yet.',
      totalVotes: count => `Total ${count} ratings`,
      yourRatingReset: 'Reset your vote',
      noRatings: 'No ratings yet',
      mobileModalHeader: 'Add your rating',
      averageRating: 'Среден рейтинг',
      reset: 'нулиране',
    },

    share: {
      share: 'Споделяне с',
      copy: 'Копиране на линка',
    },

    sort: {
      sort: 'Сортиране',
    },

    status: {
      opening: {
        open: 'Open',
        filled: 'Filled',
        cancelled: 'Cancelled',
        closed: 'Closed',
        draft: 'Draft',
        unpublished: 'Unpublished',
        hidden: 'Hidden',
      },
      person: {
        hired: 'Hired',
        proceed: 'Proceed',
        new: 'New',
        videointerviewed: 'Video interview',
        personalinterview: 'Personal interview',
        rejected: 'Rejected',
      },
    },

    supportLink: 'support@recright.com',

    typeSelect: {
      selected: 'Избрано',
      change: 'Промени',
    },

    video: {
      videoNotFound: 'Видеоклипът се обработва или видеоклипът не е намерен',
      retry: 'Опитай пак',
      originalLanguageLabel: 'Оригинал',
      englishLanguageLabel: 'Английски',
    },

    videoUpload: {
      uploadPlaceholder: isMobile => (isMobile ? 'Качване или записване на нов видеоклип' : 'Избери файл'),
      videoPlaceholder: 'Запишете Вашия отговор',
      uploadPlaceholderCandidate: 'Качване на видеоклип',
      submit: 'Изпрати отговор',
      notAnswered: 'Все още не сте отговорили',
      remove: 'Премахване на кадри',
      converting: 'Видеоклипът се конвертира. Моля, изчакайте...',
      uploading: 'Видеоклипът се качва. Моля, изчакайте...',
      error: {
        invalid: 'Избраният файл е твърде голям. Моля, изберете друг файл.',
        upload: 'Съжаляваме, но не успяхме да качим видеоклипа. Моля, опитайте отново.',
        transcode: 'Избраният видео файл е повреден или не е валиден. Моля, опитайте отново.',
      },
    },

    virtualBg: {
      showMoreButtonText: 'Покажи повече',
      showLessButtonText: 'Покажи по-малко',
      infoText1:
        'Поддържайте раздела активен на преден план, докато записвате. Не трябва да използвате друго приложение по време на запис.',
      infoText2:
        'Видеоклиповете за фон работят най-добре в най-новите браузъри и сустройство, което е сравнително ново и мощно.',
      infoText3:
        'Уверете се, че други приложения не използват вашия микрофон иликамера.',
    },

    webcam: {
      useVideoBgButtonText: 'Използване на видео фон',
      removeVideoBgButtonText: 'Използване на видео фон',
      starting: 'Стартира...',
      close: 'Затваряне на камерата',
      remove: 'Премахване на кадри',
      record: 'Записване',
      stop: 'Стоп',
      retake: 'Запиши отново',
      submit: 'Изпрати отговор',
      converting: 'Видеоклипът се конвертира. Моля, изчакайте...',
      uploading: 'Видеоклипът се качва. Моля, изчакайте...',
      downloading: 'Видеоклипът се изтегля. Моля, изчакайте...',
      processing: 'Обработва се...',
      uploadInProgress: 'Прехвърлянето на видеоклипа все още е в ход, не затваряйте браузъра или не променяйте страницата.',
      uploaded: 'Видеоклипът е прехвърлен.',
      error: {
        DevicesNotFoundError: 'Камерата или микрофонът не могат да се използват. Моля, проверете дали са активирани.',
        NotFoundError: 'Камерата или микрофонът не могат да се използват. Моля, проверете дали са активирани.',
        NotAllowedError: 'Не сте дали разрешение за използване на камерата или микрофона.',
        PermissionDismissedError: 'Не сте обърнали внимание на диалоговия прозорец за разрешения. Моля, дайте разрешение за използване на камерата и микрофона.',
        PermissionDeniedError: 'Отказали сте достъп до камерата или микрофона.',
        NotReadableError: 'Не може да се прочете потока от камерата или микрофона. Възможен хардуерен проблем.',
        SecurityError: 'Не може да се използва камерата или микрофонът поради грешка в сигурността.',
        stream: 'Възникна грешка. Моля, стартирайте отново Вашия браузър. Ако проблемът продължава, моля, опитайте с друг браузър.',
        download: 'Изтеглянето на видеоклипа е неуспешно. Опитайте отново',
        upload: 'Качването на видеоклипа е неуспешно. Опитайте отново',
        emptyBlob: 'Паметта на браузъра или на устройството Ви е пълна и не е в състояние да създаде записа. Моля, опреснете страницата и ако това не помогне, рестартирайте браузъра.  Ако проблемът продължава, моля, опитайте с друг браузър.',
        alternativeRecorder: 'Можете също да качите файл, като щракнете върху това.',
        reconnecting: 'Връзката беше прекъсната. Опит за повторно свързване.',
      },
    },

    videoResponse: {
      videoPlaceholder: 'Запишете Вашия отговор',
      uploadPlaceholder: 'Качване на видеоклип',
      submit: 'Изпрати отговор',
      notAnswered: 'Все още не сте отговорили',
      required: 'Този въпрос изисква отговор',
      startInterview: 'Започнете интервюто',
    },

    smsMessages: {
      invitationMessage: title =>
        `Здравей! Искаме да Ви поканим на видео интервю ${title}! Тази покана беше и изпратена на Вашия имейл. `,
    },
  },
  page: {
    interviewPreview: {
      info: 'This is a preview of the interview. Video recording is disabled and the form data is not saved.',
    },
  },
}
